import { Outlet, createBrowserRouter } from 'react-router';
import { Dashboard, Login, Queue } from './routes';
import { ProtectedRoute } from 'controlled-components';
import { Error404 } from 'ui-components';
import { Suspense } from 'react';
import { PageLoading, StoreAdminLayout } from 'stylist/components';
import StorePubSubInit from './StorePubSubInit';

export default createBrowserRouter([
  {
    path: '/',
    element: <Login />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    element: (
      <ProtectedRoute>
        <StorePubSubInit />
        <StoreAdminLayout>
          <Suspense fallback={<PageLoading />}>
            <Outlet />
          </Suspense>
        </StoreAdminLayout>
      </ProtectedRoute>
    ),
    children: [
      {
        path: '/dashboard',
        element: <Dashboard />,
      },
      {
        path: '/queue',
        element: <Queue />,
      },
    ],
  },
  {
    path: '/not-found',
    element: <Error404 />,
  },
  {
    path: '*',
    element: <Error404 />,
  },
]);
